import React from "react";
import { 
  Ticket, 
  User, 
  Clock, 
  FileText, 
  CheckSquare, 
  MessageSquare, 
  StickyNote 
} from "lucide-react";

export function getResultIcon(type: string): React.ReactNode {
  switch (type) {
    case "doc":
      return <FileText className="h-4 w-4 text-blue-600" />;
    case "ticket":
      return <Ticket className="h-4 w-4 text-blue-500" />;
    case "contact":
      return <User className="h-4 w-4 text-green-500" />;
    case "time_entry":
      return <Clock className="h-4 w-4 text-orange-500" />;
    case "proposal":
      return <FileText className="h-4 w-4 text-purple-500" />;
    case "note":
      return <StickyNote className="h-4 w-4 text-yellow-500" />;
    case "task":
      return <CheckSquare className="h-4 w-4 text-indigo-500" />;
    case "message":
      return <MessageSquare className="h-4 w-4 text-cyan-500" />;
    case "template":
      return <FileText className="h-4 w-4 text-pink-500" />;
    default:
      return <FileText className="h-4 w-4 text-gray-400" />;
  }
}
